
      import { ServiceFormPage } from '/src/features/service-form/service-form-page.ts';

      document.addEventListener('DOMContentLoaded', () => {
        // 自动填充接机时间（当前时间 +2 小时）
        const pickupInput = document.querySelector('input[name="pickup_time"]');
        if (pickupInput && !pickupInput.value) {
          const now = new Date();
          now.setHours(now.getHours() + 2);
          pickupInput.value = now.toISOString().slice(0, 16);
        }

        new ServiceFormPage({
          formType: 'airportPickup',
          formEl: 'airportPickupForm',
          messages: {
            loading: '正在提交接机预约...',
            success: '接机预约提交成功！我们会尽快与您联系。',
          },
        });
      });
    